const normalizeGoogleAddressComponents = components =>
  components
    .map(({ long_name: longName, short_name: shortName, types }) => ({
      longName,
      shortName,
      types
    }));

export default normalizeGoogleAddressComponents;
